"use client";

import { useTheme } from "next-themes";
import Marquee from "react-fast-marquee";

import { Panel } from "./panel";

const credentials = [
  {
    src: "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753553457/personal-website-v4/UpworkFull_ycx2cu.png",
    srcDark:
      "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753553456/personal-website-v4/UpworkDarkFull_dzc2be.png",
    title: "Upwork Top Rated Plus",
  },
  {
    src: "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753572678/personal-website-v4/Seperator_woqlhy.png",
    srcDark:
      "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753572680/personal-website-v4/SeperatorDark_nffeis.png",
    title: "Seperator",
  },
  {
    src: "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753045815/personal-website-v4/Discord_hyu2n3.png",
    srcDark:
      "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753045816/personal-website-v4/DiscordDark_xjtm1d.png",
    title: "Discord Active Developer",
  },
  {
    src: "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753572678/personal-website-v4/Seperator_woqlhy.png",
    srcDark:
      "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753572680/personal-website-v4/SeperatorDark_nffeis.png",
    title: "Seperator",
  },
  {
    src: "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753045285/personal-website-v4/AWSDVA_zgqvwl.png",
    srcDark:
      "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753045265/personal-website-v4/AWSDVADark_v0de8w.png",
    title: "AWS Certified Cloud Practitioner",
  },
  {
    src: "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753572678/personal-website-v4/Seperator_woqlhy.png",
    srcDark:
      "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753572680/personal-website-v4/SeperatorDark_nffeis.png",
    title: "Seperator",
  },
  {
    src: "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753045285/personal-website-v4/AWSCCP_v8urig.png",
    srcDark:
      "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753045265/personal-website-v4/AWSCCPDark_khwnf4.png",
    title: "AWS Certified Cloud Practitioner",
  },
  {
    src: "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753572678/personal-website-v4/Seperator_woqlhy.png",
    srcDark:
      "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753572680/personal-website-v4/SeperatorDark_nffeis.png",
    title: "Seperator",
  },
  {
    src: "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753045285/personal-website-v4/MongoDB_ownvku.png",
    srcDark:
      "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753045276/personal-website-v4/MongoDBDark_mrngfw.png",
    title: "MongoDB Developer Associate",
  },
  {
    src: "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753572678/personal-website-v4/Seperator_woqlhy.png",
    srcDark:
      "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753572680/personal-website-v4/SeperatorDark_nffeis.png",
    title: "Seperator",
  },
  {
    src: "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753045284/personal-website-v4/GCP_y17di6.png",
    srcDark:
      "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753045269/personal-website-v4/GCPDark_dt7vfs.png",
    title: "GCP Associate Cloud Engineer",
  },
  {
    src: "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753572678/personal-website-v4/Seperator_woqlhy.png",
    srcDark:
      "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753572680/personal-website-v4/SeperatorDark_nffeis.png",
    title: "Seperator",
  },
  {
    src: "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753571973/personal-website-v4/Companies_sy7kbm.png",
    srcDark:
      "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753573972/personal-website-v4/CompaniesDark_zwwsn6.png",
    title:
      "Companies & Organizations I've Been Involved With: JPME, Berexia, Central Bank of Morocco, MyUnisoft, Cegid, Station F, Microverse, MongoDB, Enactus",
  },
  {
    src: "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753572678/personal-website-v4/Seperator_woqlhy.png",
    srcDark:
      "https://res.cloudinary.com/dgihbgsnz/image/upload/v1753572680/personal-website-v4/SeperatorDark_nffeis.png",
    title: "Seperator",
  },
];

export function RotatingCredentials() {
  const { resolvedTheme } = useTheme();

  return (
    <Panel>
      <div className="relative overflow-hidden py-4">
        <Marquee
          gradient={true}
          gradientColor={resolvedTheme === "dark" ? "#000000" : "#FFFFFF"}
          gradientWidth={100}
          speed={60}
          pauseOnHover={true}
        >
          {credentials.map((credential, index) => (
            <img
              key={index}
              loading="lazy"
              src={
                resolvedTheme === "dark" ? credential.srcDark : credential.src
              }
              alt=""
              className="mx-6 h-12 w-auto"
              title={credential.title}
            />
          ))}
        </Marquee>
      </div>
    </Panel>
  );
}
